<mat-sidenav-container class="mr-container">

  <!-- Rights Sidenav -->
  <mat-sidenav #sidenav mode="over" position="end" class="mr-sidenav" (closed)="onDrawerClosed()">
    <div class="sidenav-header">
      <div class="sidenav-title">
        <mat-icon>manage_accounts</mat-icon>
        <span>Set Rights</span>
      </div>
      <button mat-icon-button (click)="sidenav.close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div *ngIf="selectedBusinessProcess" class="sidenav-bp-info">
      <p class="bp-name">{{ selectedBusinessProcess.name }}</p>
      <p class="bp-display">{{ selectedBusinessProcess.displayName }}</p>
    </div>

    <mat-divider></mat-divider>

    <div class="sidenav-body">

      <!-- Wizard stepper: Activity → Action → Teams -->
      <mat-stepper #rightsStepper [linear]="true" orientation="vertical" class="rights-stepper">

        <!-- Step 1: Select Activity -->
        <mat-step label="Select Activity" [completed]="!!selectedActivity">
          <div class="step-content">
            <div *ngIf="!selectedBusinessProcess?.activities?.length" class="sidenav-empty-step">
              <mat-icon>info_outline</mat-icon>
              <p>No activities defined.</p>
            </div>
            <mat-action-list *ngIf="selectedBusinessProcess?.activities?.length">
              <button mat-list-item *ngFor="let act of selectedBusinessProcess?.activities"
                (click)="selectActivity(act)" class="wizard-list-item">
                <mat-icon matListItemIcon color="primary">category</mat-icon>
                <span matListItemTitle>{{ act.name }}</span>
              </button>
            </mat-action-list>
          </div>
        </mat-step>

        <!-- Step 2: Select Action -->
        <mat-step label="Select Action" [completed]="!!selectedAction">
          <div class="step-content">
            <div class="step-context-pill">
              <mat-icon>category</mat-icon>
              <span>{{ selectedActivity?.name }}</span>
            </div>
            <mat-action-list *ngIf="selectedActivity?.actions?.length">
              <button mat-list-item *ngFor="let action of selectedActivity?.actions" (click)="selectAction(action)"
                class="wizard-list-item">
                <mat-icon matListItemIcon color="accent">bolt</mat-icon>
                <span matListItemTitle>{{ action.name }}</span>
              </button>
            </mat-action-list>
            <div *ngIf="!selectedActivity?.actions?.length" class="sidenav-empty-step">
              <mat-icon>info_outline</mat-icon>
              <p>No actions for this activity.</p>
            </div>
            <div class="step-nav">
              <button mat-button (click)="backToActivities()">
                <mat-icon>arrow_back</mat-icon> Back
              </button>
            </div>
          </div>
        </mat-step>

        <!-- Step 3: Assign Teams -->
        <mat-step label="Assign Teams" [completed]="!!pendingTeam">
          <div class="step-content">
            <div class="step-context-pill">
              <mat-icon>bolt</mat-icon>
              <span>{{ selectedAction?.name }}</span>
              <span class="pill-sep">in</span>
              <span>{{ selectedActivity?.name }}</span>
            </div>
            <div class="team-checkbox-list" *ngIf="assignableTeams.length">
              <div *ngFor="let team of assignableTeams" class="team-checkbox-row"
                [class.team-assigned]="hasRight(selectedAction, team)">
                <mat-checkbox [checked]="hasRight(selectedAction, team)" [disabled]="isTeamLoading(team)"
                  (change)="toggleRight(selectedActivity, selectedAction, team)">
                  {{ team.name }}
                </mat-checkbox>
                <mat-spinner *ngIf="isTeamLoading(team)" diameter="16" class="inline-spinner"></mat-spinner>
              </div>
            </div>
            <div *ngIf="!assignableTeams.length" class="sidenav-empty-step">
              <mat-icon>people_outline</mat-icon>
              <p>No assignable teams. All existing teams are system-protected.</p>
            </div>
            <div class="step-nav">
              <button mat-button (click)="backToActions()">
                <mat-icon>arrow_back</mat-icon> Back
              </button>
            </div>
          </div>
        </mat-step>

        <!-- Step 4: Confirm Change -->
        <mat-step label="Confirm Change">
          <div class="step-content">
            <div class="confirm-summary" [class.confirm-revoke-mode]="pendingOperation === 'revoke'">
              <div class="confirm-icon-wrap">
                <mat-icon class="confirm-main-icon" [class.revoke-icon]="pendingOperation === 'revoke'">
                  {{ pendingOperation === 'revoke' ? 'remove_circle_outline' : 'add_circle_outline' }}
                </mat-icon>
              </div>
              <p class="confirm-headline">
                You are about to
                <strong>{{ pendingOperation === 'revoke' ? 'revoke' : 'assign' }}</strong>
                a right
              </p>
              <div class="confirm-details">
                <div class="confirm-detail-row">
                  <span class="confirm-label">Action</span>
                  <span class="confirm-value">{{ selectedAction?.name }}</span>
                </div>
                <div class="confirm-detail-row">
                  <span class="confirm-label">Team</span>
                  <span class="confirm-value">{{ pendingTeam?.name }}</span>
                </div>
                <div class="confirm-detail-row">
                  <span class="confirm-label">Activity</span>
                  <span class="confirm-value">{{ selectedActivity?.name }}</span>
                </div>
                <div class="confirm-detail-row">
                  <span class="confirm-label">Business Process</span>
                  <span class="confirm-value">{{ selectedBusinessProcess?.displayName || selectedBusinessProcess?.name
                    }}</span>
                </div>
              </div>
            </div>
            <div class="step-nav confirm-nav">
              <button mat-button (click)="cancelRightsChange()">
                <mat-icon>arrow_back</mat-icon> Back
              </button>
              <button mat-raised-button [color]="pendingOperation === 'revoke' ? 'warn' : 'primary'"
                (click)="confirmRightsChange()">
                <mat-icon>{{ pendingOperation === 'revoke' ? 'remove_circle' : 'check_circle' }}</mat-icon>
                {{ pendingOperation === 'revoke' ? 'Revoke Right' : 'Assign Right' }}
              </button>
            </div>
          </div>
        </mat-step>

      </mat-stepper>

    </div>
  </mat-sidenav>

  <!-- Main Content -->
  <mat-sidenav-content>
    <div class="mr-page">

      <!-- Toolbar -->
      <mat-card class="mr-toolbar-card">
        <mat-card-content class="mr-toolbar">
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>Search</mat-label>
            <input matInput [(ngModel)]="searchTerm" (input)="onSearchChange()" placeholder="Search by name...">
            <mat-icon matPrefix>search</mat-icon>
            <button *ngIf="searchTerm" matSuffix mat-icon-button (click)="searchTerm=''; onSearchChange()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </mat-card-content>
      </mat-card>

      <!-- Table -->
      <mat-card class="mr-table-card">
        <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

        <table mat-table [dataSource]="dataSource" matSort class="mr-table">

          <!-- Display Name Column (shown in place of internal name) -->
          <ng-container matColumnDef="displayName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
            <td mat-cell *matCellDef="let bp" class="name-cell">{{ bp.displayName || bp.name }}</td>
          </ng-container>

          <!-- Description Column -->
          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef>Description</th>
            <td mat-cell *matCellDef="let bp" class="description-cell">{{ bp.description }}</td>
          </ng-container>

          <!-- Active Column -->
          <ng-container matColumnDef="isActive">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Active</th>
            <td mat-cell *matCellDef="let bp">
              <span class="active-chip" [class.chip-yes]="bp.isActive" [class.chip-no]="!bp.isActive">
                {{ bp.isActive ? 'Yes' : 'No' }}
              </span>
            </td>
          </ng-container>

          <!-- Rights Column -->
          <ng-container matColumnDef="rights">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let bp" class="rights-cell">
              <button mat-icon-button [color]="selectedBusinessProcess?.id === bp.id ? 'primary' : ''"
                (click)="noAssignableTeams ? notify('No assignable teams — all teams are system-protected', 'warning') : openSetRightsDrawer(bp)"
                [matTooltip]="noAssignableTeams ? 'No assignable teams — all teams are system-protected' : 'Set Rights'">
                <mat-icon>admin_panel_settings</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"
            [class.row-active]="selectedBusinessProcess?.id === row.id"></tr>

          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">
              <div class="no-data-message">
                <mat-icon>inbox</mat-icon>
                <p>No business processes found</p>
              </div>
            </td>
          </tr>
        </table>

        <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" appPersistPageSize="businessProcesses:list" showFirstLastButtons></mat-paginator>
      </mat-card>

    </div>
  </mat-sidenav-content>

</mat-sidenav-container>
